/**
 * 缓冲区查询组件
 * @module BufferDrawComponent
 */
'use strict';
define([
    '../base/PureComponent',
    '../utils/LayerUtil',
    '../utils/CommonUtil',
    '../utils/GeometryUtil',
    '../g2'
], function (
    PureComponent,
    LayerUtil,
    CommonUtil,
    GeometryUtil,
    g2
) {
    var COMMANDNAMES = {
        'NoopTool': 'NoopTool'
    };
    //拖动圆的tool，控制圆大小，完成拖动后查询
    var circleEditTool = g2.interact.Tool.extend({
        initialize: function (opt) {
            var opts = opt || {};
            g2.interact.Tool.call(this, opts);
            this.parent = opts.parent;
            this.onMove = -1;
            this.currentElement = null;
            this.center = opts.center;
            this.map = opts.map;
            this.drawLayer = opts.drawLayer;
            this.circleEle = opts.circleEle;
            this.lineEle = opts.lineEle;
            this.picEle = opts.picEle;
            this.textEle = opts.textEle;
            this.geoSearch = opts.geoSearch;
            this.callback = opts.callBack;
            this.query = opts.query;
            this.context = opts.context;
            this.markerSymbol = opts.markerSymbol;
            this.fillSymbol = opts.fillSymbol;
        },
        onMouseUp: function (button, shift, screenx, screeny, mapx, mapy, handled) {
            this.map.resumeDragPan();
            if (this.onMove == 0) {
                this.onMove = -1;
            } else if (this.onMove > 0) {
                var self = this;
                var cjson = {
                    x: this.center.x,
                    y: this.center.y,
                    radius: this.radius,
                    count: 128
                };
                var geoJson = this.parent._getCircleGeoJson(cjson)
                self.callback.call(self.context, geoJson, this.textlength);
                this.onMove = -1;
                this.currentElement = null;
                this.drawLayer.update(this.picEle, true);
            }
        },
        onMouseDown: function (button, shift, screenx, screeny, mapx, mapy, handled) {
            if (this.onMove < 0) {
                var graphic = this.drawLayer.hitTest(screenx, screeny);
                if (graphic) {
                    this.map.stopDragPan();
                    if (!!graphic && this.picEle.id == graphic.element.id) {
                        this.currentElement = graphic.element;
                        this.onMove++;
                        this.drawLayer.update(this.picEle, true);
                    }
                }
            }
        },
        onMouseMove: function (button, shift, screenx, screeny, mapx, mapy, handled) {
            if (this.onMove >= 0) {
                if (!!this.currentElement) {
                    this.currentElement.geometry.x = mapx;
                    this.currentElement.geometry.y = this.center.y;
                    this.drawLayer.update(this.currentElement);

                    //画线处理
                    var polyline = new g2.sfs.Polyline({
                        spatialReference: this.map.spatialReference
                    });
                    var path = new g2.sfs.Path({
                        spatialReference: this.map.spatialReference
                    });
                    var point1 = this.center;
                    var point2 = new g2.sfs.Point({
                        x: mapx,
                        y: this.center.y,
                        spatialReference: this.map.spatialReference
                    })
                    path.addPoint(point1);
                    path.addPoint(point2);
                    polyline.addGeometry(path);
                    this.lineEle.geometry = polyline;
                    this.drawLayer.update(this.lineEle);
                    //圆
                    this.radius = Math.abs(point1.x - point2.x);
                    //this.circleEle.geometry.radius = this.radius;

                    var projectService = new g2.sfs.CoordinateTransform();
                    var measureService = new g2.sfs.MeasureService({
                        projectService: projectService
                    });
                    this.textlength = measureService.length(this.lineEle.geometry);
                    this.textEle.symbol.text = Math.round(this.textlength) / 1000 + "km";
                    this.drawLayer.update(this.textEle, true);
                    this.drawLayer.remove(this.circleEle);
                    var cjson = {
                        x: this.center.x,
                        y: this.center.y,
                        radius: this.textlength,
                        count: 128
                    };
                    var centerGeom = new g2.sfs.Point({
                        x: this.center.x,
                        y: this.center.y,
                        spatialReference: this.map.spatialReference
                    });
                    var geoJson = this.parent._getBufferGeoJson(centerGeom, this.textlength);
                    //var geoJson = this.parent.getCircleGeoJson(cjson);
                    var polygonGeometry = g2.sfs.GeometryFactory.createGeometryFromGeoJson(geoJson, this.map.spatialReference);
                    var ring = new g2.sfs.Ring({
                        spatialReference: this.map.spatialReference
                    });
                    polygonGeometry.addGeometry(ring);
                    var fillSymbol = this.fillSymbol;
                    var circleEle = new g2.sfs.Element({
                        geometry: polygonGeometry,
                        symbol: fillSymbol
                    });
                    this.circleEle = circleEle;
                    this.drawLayer.add(this.circleEle);
                    //文字
                    this.onMove++;
                }
            }
        },
        onMouseClick: function (button, shift, screenx, screeny, mapx, mapy, handled) {

        }
    })

    //拖动面状的tool，控制圆大小，完成拖动后查询
    var polygonEditTool = g2.interact.Tool.extend({
        initialize: function (opt) {
            var opts = opt || {};
            g2.interact.Tool.call(this, opts);
            this.onMove = -1;
            this.currentElement = null;
            this.geometry = opts.geometry;
            this.map = opts.map;
            this.drawLayer = opts.drawLayer;
            this.lineEle = opts.lineEle;
            this.picEle = opts.picEle;
            this.bufferEle = opts.bufferEle;
            this.maxPoint = opts.maxPoint;
            this.bufferMaxPoint = opts.bufferMaxPoint;
            this.callback = opts.callBack;
            this.context = opts.context;
            this.parent = opts.parent;
            this.textEle = opts.textEle;
            this.fillSymbol = opts.fillsymbol;
        },
        onMouseUp: function (button, shift, screenx, screeny, mapx, mapy, handled) {
            this.map.resumeDragPan();
            if (this.onMove == 0) {
                this.onMove = -1;
            } else if (this.onMove > 0) {
                var self = this;
                self.callback.call(self.context, this.bufferGeoJSON, this.textlength);
                this.onMove = -1;
                this.currentElement = null;
                this.drawLayer.update(this.picEle, true);
            }
        },
        onMouseDown: function (button, shift, screenx, screeny, mapx, mapy, handled) {
            if (this.onMove < 0) {
                var graphic = this.drawLayer.hitTest(screenx, screeny);
                if (graphic) {
                    this.map.stopDragPan();
                    if (!!graphic && this.picEle.id == graphic.element.id) {
                        this.currentElement = graphic.element;
                        this.onMove++;
                        //this.drawLayer.update(this.picEle,true);
                    }
                }
            }
        },
        onMouseMove: function (button, shift, screenx, screeny, mapx, mapy, handled) {
            if (this.onMove >= 0) {
                if (!!this.currentElement) {
                    //this.currentElement.geometry.x = mapx;
                    //this.currentElement.geometry.y = this.bufferMaxPoint.y;
                    //this.drawLayer.update(this.currentElement);
                    var point1 = this.maxPoint;
                    var point2 = new g2.sfs.Point({
                        x: mapx,
                        y: mapy,
                        spatialReference: this.map.spatialReference
                    })
                    var polyline = new g2.sfs.Polyline({
                        spatialReference: this.map.spatialReference
                    });
                    var path = new g2.sfs.Path({
                        spatialReference: this.map.spatialReference
                    });
                    path.addPoint(point1);
                    path.addPoint(point2);
                    polyline.addGeometry(path);
                    this.lineEle.geometry = polyline;
                    //缓冲面
                    this.radius = Math.abs(point1.x - point2.x);
                    var projectService = new g2.sfs.CoordinateTransform();
                    var measureService = new g2.sfs.MeasureService({
                        projectService: projectService
                    });
                    this.textlength = measureService.length(this.lineEle.geometry);
                    this.drawLayer.remove(this.bufferEle);
                    var reader = new jsts.io.GeoJSONReader();
                    var input = reader.read(this.geometry);
                    input = input.buffer(this.textlength * (360 / (2 * Math.PI * 6378137))); //缓冲buffer米
                    this.bufferGeoJSON = new jsts.io.GeoJSONWriter().write(input);
                    var geoJson = this.bufferGeoJSON;

                    var polygonGeometry = g2.sfs.GeometryFactory.createGeometryFromGeoJson(geoJson, this.map.spatialReference);
                    var ring = new g2.sfs.Ring({
                        spatialReference: this.map.spatialReference
                    });
                    polygonGeometry.addGeometry(ring);
                    var fillSymbol = this.fillSymbol;
                    this.bufferEle = new g2.sfs.Element({
                        geometry: polygonGeometry,
                        symbol: fillSymbol
                    });
                    this.drawLayer.add(this.bufferEle);

                    //点的位置
                    var arr = geoJson.coordinates;
                    var list = this.parent._sortFunction(arr, geoJson.type);
                    var point = new g2.sfs.Point({
                        x: list[0][0],
                        y: list[0][1],
                        spatialReference: this.map.spatialReference
                    })
                    //this.currentElement.geometry.x = mapx;
                    //this.currentElement.geometry.y = this.bufferMaxPoint.y;
                    this.currentElement.geometry = point;
                    this.drawLayer.update(this.currentElement);
                    //画线处理
                    var polyline1 = new g2.sfs.Polyline({
                        spatialReference: this.map.spatialReference
                    });
                    var path1 = new g2.sfs.Path({
                        spatialReference: this.map.spatialReference
                    });
                    path1.addPoint(point1);
                    path1.addPoint(point);
                    polyline1.addGeometry(path1);
                    this.lineEle.geometry = polyline1;
                    this.drawLayer.update(this.lineEle);
                    //文字
                    var projectService = new g2.sfs.CoordinateTransform();
                    var measureService = new g2.sfs.MeasureService({
                        projectService: projectService
                    });
                    this.textlength = measureService.length(this.lineEle.geometry);

                    this.drawLayer.remove(this.textEle);
                    var text = Math.round(this.textlength) / 1000 + "km";
                    var textSymbol = new g2.sfs.TextSymbol({
                        text: text,
                        foreground: new g2.sfs.Color({r: 255, g: 0, b: 0, a: 255}),
                        offsetX: 10,
                        offsetY: -13,
                        rotation: 0
                    });
                    this.textEle = new g2.sfs.Element({geometry: polyline1, symbol: textSymbol});
                    this.drawLayer.add(this.textEle);
                    //
                    this.onMove++;

                }
            }
        },
        onMouseClick: function (button, shift, screenx, screeny, mapx, mapy, handled) {

        }
    })
    /***********************缓冲区查询**************************/
    var component = PureComponent.extend({
        options: {
            "name": "缓冲区查询 ",
            "buffer_img": "data:image/png;base64,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"
        },
        /**
         * @constructor
         * @classdesc 缓冲区查询组件
         * @alias G.components.BufferDrawComponent
         * @augments G.base.PureComponent
         * @param options {Object} 必填
         * @param options.map {G.Map} 必填，地图对象
         * @param options.layerId {String} 可选，图层id，不传自动创建新图层
         */
        initialize: function (options) {
            PureComponent.prototype.initialize.call(this, options);
            //
            var g2Map = this.map.getMap();
            this.options.layerId = this.options.layerId || CommonUtil.newUUID32();
            var layer = LayerUtil.getLayerById(this.map, this.options.layerId);
            if (!layer) {
                layer = new g2.carto.ElementLayer({
                    id: this.options.layerId,
                    map: g2Map
                });
                g2Map.addLayer(layer);
            }
            this._layer = layer;
        },
        /**
         * 销毁
         * @method
         */
        destroy: function () {
            var g2Map = this.map.getMap();
            this._layer.clear();
            g2Map.removeLayer(this._layer);
            //
            PureComponent.prototype.destroy.call(this);
        }
    })
    /**
     * 组件对外接口
     * */
    component.include({
        /**
         * 缓冲区预取值
         * @method
         * @param options {Object} 必填
         * @param options.type {String} 缓冲区查询的类型，必填
         * @param options.callback {Function} 回调函数，选填
         * @param options.content {Object} 上下文，选填
         */
        drawBuffer: function (options) {
            this.clearBufferLayer();
            if (CommonUtil.isEmptyObject(options)) {
                throw new Error("传入参数错误！")
            }
            this.param = options;
            var type = options.type;
            this._noopTool();
            this.map.off('click', this._getMapPolt());
            this.map.off('click', this._getMapClickPoint());
            if (type == "point") { //获取点
                this.map.listen('click', this._getMapClickPoint());
            }
            if (type == "polyline") { //线
                this._drawPolyline(options);
            }
            if (type == "getGeo") { //自定义拾取
                this.map.listen('click', this._getMapPolt());
            }
        },
        /**
         * 可拖拽的圆缓冲区
         * @method
         * @memberOf G.components.BufferDrawComponent.prototype
         * @param options {Object} 必填
         * @param options.mapX {String} 必填，经度
         * @param options.mapY {String} 必填，纬度
         * @param options.radius {String} 必填，中心缓冲半径
         * @param options.callback {Function} 选填，回调函数，返回选中的geoJson和角度
         * @param options.symbol {Object} 选填，符号设置
         * @param options.context {Object} 选填，上下文
         */
        circleBuffer: function (options) {
            this.clearBufferLayer();
            var mapX = options.mapX;
            var mapY = options.mapY;
            var radius = options.radius;
            var context = options.context;
            var callback = options.callback;
            var drawLayer = this._layer;
            var showDrag, showLine;
            if (options.showDrag == false) {
                showDrag = options.showDrag;
            } else {
                showDrag = true;
            }
            if (options.showLine == false) {
                showLine = options.showLine;
            } else {
                showLine = true;
            }

            var map = this.map;
            var fillSymbol = options.symbol || new g2.sfs.SimpleFillSymbol();
            var point = new g2.sfs.Point({
                x: mapX,
                y: mapY,
                spatialReference: map.spatialReference
            })
            var paramobj = {
                x: mapX,
                y: mapY,
                radius: radius,
                angle: 90,
                srs: map.spatialReference
            }
            var circleInPoint = this._getCirclePointByAngle(paramobj);
            if (showDrag) {
                var img = this.options.buffer_img;
                var markerSymbol = new g2.sfs.PictureMarkerSymbol({
                    source: img,
                    width: 32,
                    height: 20,
                    rotation: "0",
                    opacity: "1",
                    offsetX: "2",
                    offsetY: "5"
                });
                this.picEle = new g2.sfs.Element({
                    id: "moveMarker",
                    geometry: circleInPoint,
                    symbol: markerSymbol
                });
                drawLayer.add(this.picEle);
            }
            //画直线
            var ploylineSymbol = new g2.sfs.SimpleLineSymbol({
                color: new g2.sfs.Color({
                    a: 153,
                    r: 255,
                    g: 0,
                    b: 0
                })
            });
            var polyline = new g2.sfs.Polyline({
                spatialReference: map.spatialReference
            });
            var path = new g2.sfs.Path({
                spatialReference: map.spatialReference
            });
            var point1 = point;
            var point2 = circleInPoint;
            path.addPoint(point1);
            path.addPoint(point2);
            polyline.addGeometry(path);
            this.polylineElement = new g2.sfs.Element({
                geometry: polyline,
                symbol: ploylineSymbol
            });

            //标文字
            var projectService = new g2.sfs.CoordinateTransform();
            var measureService = new g2.sfs.MeasureService({
                projectService: projectService
            });
            var textlength = measureService.length(this.polylineElement.geometry);
            //构造文本符号
            var text = Math.round(textlength) / 1000 + "km";
            var textSymbol = new g2.sfs.TextSymbol({
                text: text,
                foreground: new g2.sfs.Color({
                    r: 255,
                    g: 0,
                    b: 0,
                    a: 255
                }),
                offsetX: 10,
                offsetY: -13,
                rotation: 0
            });
            this.textEle = new g2.sfs.Element({
                geometry: point,
                symbol: textSymbol
            });
            if (showLine) {
                drawLayer.add(this.polylineElement);
                drawLayer.add(this.textEle);
            }
            //激活tool
            var cjson = {
                x: mapX,
                y: mapY,
                center: [mapX, mapY],
                radius: radius,
                count: 128,
                srs: map.spatialReference
            };
            /***
             * 根据中心点半径获取缓冲区geojson
             * @type {Array}
             */
            var centerGeom = new g2.sfs.Point({
                x: mapX,
                y: mapY,
                spatialReference: map.spatialReference
            });
            var geoJson = this._getBufferGeoJson(centerGeom, radius);
            var polygonGeometry = g2.sfs.GeometryFactory.createGeometryFromGeoJson(geoJson, map.spatialReference);
            var ring = new g2.sfs.Polygon({
                spatialReference: map.spatialReference
            });
            polygonGeometry.addGeometry(ring);
            this.circleEle = new g2.sfs.Element({
                geometry: polygonGeometry,
                symbol: fillSymbol
            });
            drawLayer.add(this.circleEle);
            if (showDrag) {
                var tool = new circleEditTool({
                    center: point,
                    parent: this,
                    callBack: callback,
                    map: map,
                    drawLayer: drawLayer,
                    circleEle: this.circleEle,
                    lineEle: this.polylineElement,
                    picEle: this.picEle,
                    textEle: this.textEle,
                    markerSymbol: markerSymbol,
                    context: context,
                    fillSymbol: fillSymbol
                });
                tool.onCreate({
                    map: map
                });
                tool.onClick();
            }
            callback.call(context, geoJson, radius);
        },
        /**
         * 可拖拽的geojson数据缓冲区
         * @method
         * @memberOf G.components.BufferDrawComponent.prototype
         * @param options {Object} 必填
         * @param options.geojson {Object} 必填，geojson数据对象（对应预选线的返回值）
         * @param options.radius {String} 必填，中心缓冲半径
         * @param options.callback {Function} 选填，回调函数，返回选中的geoJson和角度
         * @param options.symbol {Object} 选填，符号设置
         * @param options.context {Object} 选填，上下文
         */
        geojsonBuffer: function (options) {
            this.clearBufferLayer();
            var geo = options.geojson;
            var reader = new jsts.io.GeoJSONReader();
            var buffer = options.radius;
            var callback = options.callback;
            var symbol = options.symbol;
            var bufferLayer = this._layer;
            var map = this.map;
            var context = options.context;
            var showDrag, showLine;
            if (options.showDrag == false) {
                showDrag = options.showDrag;
            } else {
                showDrag = true;
            }
            if (options.showLine == false) {
                showLine = options.showLine;
            } else {
                showLine = true;
            }
            if (geo.type == "LineString" && geo.coordinates.length < 2) {
                geo.coordinates = geo.coordinates[0];
            }
            var moveGeo = $.extend(true, {}, geo);
            var input = reader.read(geo);
            var maxList = this._sortFunction(geo.coordinates, geo.type);
            var maxPoint = new g2.sfs.Point({
                x: maxList[0][0],
                y: maxList[0][1],
                spatialReference: map.spatialReference
            })

            input = input.buffer(buffer * (360 / (2 * Math.PI * 6378137)));//缓冲buffer米
            var bufferGeoJSON = new jsts.io.GeoJSONWriter().write(input);
            var arr = bufferGeoJSON.coordinates;
            var list = this._sortFunction(arr, bufferGeoJSON.type);
            var point = new g2.sfs.Point({
                x: list[0][0],
                y: list[0][1],
                spatialReference: map.spatialReference
            })
            //画直线
            var ploylineSymbol = new g2.sfs.SimpleLineSymbol({color: new g2.sfs.Color({a: 153, r: 255, g: 0, b: 0})});
            var polyline = new g2.sfs.Polyline({spatialReference: map.spatialReference});
            var path = new g2.sfs.Path({spatialReference: map.spatialReference});
            path.addPoint(maxPoint);
            path.addPoint(point);
            polyline.addGeometry(path);
            this.polylineElement = new g2.sfs.Element({geometry: polyline, symbol: ploylineSymbol});
            if (showLine) {
                bufferLayer.add(this.polylineElement);
            }
            //标文字
            //构造文本符号
            var text = Math.round(buffer) / 1000 + "km";
            var textSymbol = new g2.sfs.TextSymbol({
                text: text,
                foreground: new g2.sfs.Color({r: 255, g: 0, b: 0, a: 255}),
                offsetX: 10,
                offsetY: -13,
                rotation: 0
            });
            this.textEle = new g2.sfs.Element({geometry: this.polylineElement.geometry, symbol: textSymbol});
            bufferLayer.add(this.textEle);
            //画拖动图标
            var img = this.options.buffer_img;
            var markerSymbol = new g2.sfs.PictureMarkerSymbol({
                source: img,
                width: 32,
                height: 20,
                rotation: "0",
                opacity: "1",
                offsetX: "2",
                offsetY: "5"
            });
            var markerEle = new g2.sfs.Element({id: "moveMarker", geometry: point, symbol: markerSymbol});
            if (showDrag) {
                bufferLayer.add(markerEle);
            }
            var polygonGeometry = g2.sfs.GeometryFactory.createGeometryFromGeoJson(bufferGeoJSON, map.spatialReference);
            var fillSymbol = symbol || new g2.sfs.SimpleFillSymbol();
            var ring = new g2.sfs.Ring({spatialReference: map.spatialReference});
            polygonGeometry.addGeometry(ring);
            var polygonEle = new g2.sfs.Element({geometry: polygonGeometry, symbol: fillSymbol});
            //将element加入到图层中
            bufferLayer.add(polygonEle);
            if (showDrag) {
                var tool = new polygonEditTool({
                    maxPoint: maxPoint,
                    bufferMaxPoint: point,
                    geometry: moveGeo,
                    bufferEle: polygonEle,
                    parent: this,
                    callBack: callback,
                    map: map,
                    drawLayer: bufferLayer,
                    lineEle: this.polylineElement,
                    picEle: markerEle,
                    textEle: this.textEle,
                    fillsymbol: symbol,
                    context: context
                });
                tool.onCreate({map: map});
                tool.onClick();
            }
            callback.call(context, bufferGeoJSON, buffer);
        },
        /**
         * 清除缓冲区图层
         * @method
         * @memberOf G.components.BufferDrawComponent.prototype
         * */
        clearBufferLayer: function () {
            if (this._layer) {
                this._layer.clear();
            }
        }
    })
    /**
     * 私有方法
     * */
    component.include({
        /**
         * 初始化工具
         * */
        _noopTool: function () {
            var commandManager = new g2.gdm.CommandManager();
            //创建命令通知实例，用来命令之间的相互通知，传入命令管理对象
            var commandNotify = new g2.gmd.CommandNotify({
                manager: commandManager
            });
            var nooptool = new g2.gdm.NoopTool({
                id: COMMANDNAMES.NoopTooll,
                cursor: 'pointer'
            });
            commandManager.add(nooptool);
            var graphicSet = new g2.carto.GraphicSelectionSet();
            commandManager.onCreate({
                map: this.map,
                commandNotify: commandNotify,
                graphicSelectionSet: graphicSet,
                spatialRef: {
                    srid: this.map.spatialReference
                }
            });
            commandNotify.activeCommand(COMMANDNAMES.NoopTool, null);
        },
        /**
         * 画线
         * */
        _drawPolyline: function (param) {
            var self = this;
            var drawLayer = this._layer;
            var callback = param.callback;
            var context = param.context;
            var gsLineSymbol = param.symbol || new g2.sfs.SimpleLineSymbol();
            var path = new g2.sfs.Path({
                spatialReference: this.map.spatialReference
            });
            var polyline = new g2.sfs.Polyline({
                spatialReference: this.map.spatialReference
            });
            polyline.addGeometry(path);
            var polylineEle = new g2.sfs.Element({
                geometry: polyline,
                symbol: gsLineSymbol
            });
            //折线
            this.ploylinePlot = new g2.draw.DrawTool({
                id: "ploylinePlot",
                templateElement: polylineEle,
                layer: drawLayer,
                drawLayer: drawLayer

            });
            var projectService = new g2.sfs.CoordinateTransform();
            var measureService = new g2.sfs.MeasureService({
                projectService: projectService
            });
            this.ploylinePlot.onCreate({
                map: this.map,
                spatialRef: this.map.spatialReference,
                measureService: measureService
            }); //传入地图实例和空间坐标参考
            this.ploylinePlot.onEndDraw = function (ele) {
                drawLayer.add(ele);
                this.map.currentTool(null);
                var length = measureService.length(ele.geometry);
                var lineGeoJson = ele.geometry.asGeoJson();
                //构造文本符号
                var text = Math.round(length) / 1000 + "km";
                var textSymbol = new g2.sfs.TextSymbol({
                    text: text,
                    foreground: new g2.sfs.Color({
                        r: 255,
                        g: 0,
                        b: 0,
                        a: 255
                    }),
                    offsetX: 10,
                    offsetY: -13,
                    rotation: 0
                });
                var lineTextEle = new g2.sfs.Element({
                    geometry: ele.geometry,
                    symbol: textSymbol
                });
                drawLayer.add(lineTextEle);
                callback.call(context, lineGeoJson, length);
            };
            this.ploylinePlot.onClick();
        },
        /**
         * 根据中心点半径获取缓冲区
         * @param centerGeom {g2.sfs.Point}
         * @param radius {Number} 半径 /m
         * @private
         */
        _getBufferGeoJson: function (centerGeom, radius) {
            if (!(centerGeom && !isNaN(radius))) {
                return null;
            }
            var geoJson = null;
            var spatialRef = centerGeom.spatialReference;
            if (spatialRef == 4326) {
                var opts = {
                    center: [centerGeom.x, centerGeom.y],
                    radius: radius,
                    count: 128,
                    spatialReference: spatialRef
                };
                var circlePoints = GeometryUtil.getCirclePonits(opts);
                circlePoints.push(circlePoints[0]);
                var coordinates = [circlePoints];
                geoJson = {};
                geoJson.coordinates = coordinates;
                geoJson.type = "Polygon";
                return geoJson;
            } else if (spatialRef == 3857) {
                var projService = new g2.sfs.CoordinateTransform();
                var ptGeom = new g2.sfs.Point({
                    x: centerGeom.x,
                    y: centerGeom.y,
                    spatialReference: spatialRef
                });
                var geom4326 = projService.transform(ptGeom, 4326);
                //激活tool
                var opts = {
                    center: [geom4326.x, geom4326.y],
                    radius: radius,
                    count: 128,
                    spatialReference: 4326
                };
                var circlePoints = GeometryUtil.getCirclePonits(opts);
                var geomJson = {
                    type: 'Polygon',
                    coordinates: [circlePoints]
                }
                var geom4326pts = g2.sfs.GeometryFactory.createGeometryFromGeoJson(geomJson);
                geom4326pts.spatialReference = 4326;
                geoJson = projService.transform(geom4326pts, spatialRef).asGeoJson();
            }
            return geoJson;
        },
        _getCirclePointByAngle: function (param) {
            var x = param.x;
            var y = param.y;
            var radius = param.radius;
            var angle = param.angle;
            var srs = param.srs;
            if (srs == "3857") {
                var projService = new g2.sfs.CoordinateTransform();
                var ptGeom = new g2.sfs.Point({
                    x: param.x,
                    y: param.y,
                    spatialReference: srs
                });
                var geom4326 = projService.transform(ptGeom, 4326);
                //激活tool
                var opts = {
                    center: [geom4326.x, geom4326.y],
                    radius: radius,
                    count: 360,
                    spatialReference: 4326
                };
                var circlePoints = GeometryUtil.getCirclePonits(opts);
                var point = {
                    type: 'Point',
                    coordinates: [circlePoints[angle][0], circlePoints[angle][1]]
                }
                var geom4326pts = g2.sfs.GeometryFactory.createGeometryFromGeoJson(point);
                geom4326pts.spatialReference = 4326;
                var newpoint = projService.transform(geom4326pts, srs).asGeoJson();
                point = new g2.sfs.Point({
                    x: newpoint.coordinates[0],
                    y: newpoint.coordinates[1],
                    spatialReference: srs
                })
                return point;
            } else {
                radius = radius / 6378137;
                angle = angle * Math.PI / 180;
                var lat1 = y * Math.PI / 180,
                    lon1 = x * Math.PI / 180;
                var lat2 = Math.asin(Math.sin(lat1) * Math.cos(radius) +
                    Math.cos(lat1) * Math.sin(radius) * Math.cos(angle));
                var lon2 = lon1 + Math.atan2(Math.sin(angle) * Math.sin(radius) *
                    Math.cos(lat1),
                    Math.cos(radius) - Math.sin(lat1) *
                    Math.sin(lat2));
                if (!isNaN(lat2) || !isNaN(lon2)) {
                    var ox = lon2 * 180 / Math.PI;
                    var oy = lat2 * 180 / Math.PI;
                    var point = new g2.sfs.Point({
                        x: ox,
                        y: oy,
                        spatialReference: srs
                    })
                    return point;
                }
                ;
            }
        },
        /**
         * 获取圆的geojson
         * @param x
         * @param y
         * @param radius
         * @param count
         * @returns {{}}
         * @private
         */
        _getCircleGeoJson: function (param) {
            var x = param.x;
            var y = param.y;
            var dist = param.radius;
            var count = param.count;
            var brngs = [];
            var srs = param.srs;
            var geoJson = {};
            if (srs == "3857") {
                var pointjson = {};
                pointjson.type = "Point";
                pointjson.coordinates = [x, y];
                geoJson = this._getGeoBuffer(pointjson, dist);
            } else {
                for (var i = 0; i < count; i++) {
                    var l = 360 / count;
                    brngs.push(l * i);
                }
                geoJson.type = "Polygon"
                var coordinates = [];
                dist = dist / 6378137;
                for (var r = 0; r < brngs.length; r++) {
                    var brng = brngs[r];
                    brng = brng * Math.PI / 180;
                    var lat1 = y * Math.PI / 180, lon1 = x * Math.PI / 180;
                    var lat2 = Math.asin(Math.sin(lat1) * Math.cos(dist) +
                        Math.cos(lat1) * Math.sin(dist) * Math.cos(brng));
                    var lon2 = lon1 + Math.atan2(Math.sin(brng) * Math.sin(dist) *
                        Math.cos(lat1),
                        Math.cos(dist) - Math.sin(lat1) *
                        Math.sin(lat2));
                    if (!isNaN(lat2) || !isNaN(lon2)) {
                        var point = [];
                        var ox = lon2 * 180 / Math.PI;
                        var oy = lat2 * 180 / Math.PI;
                        point.push(ox);
                        point.push(oy);
                        coordinates.unshift(point);
                        if (r == brngs.length - 1) {
                            coordinates.push(coordinates[0]);
                        }
                    }
                    ;
                }
                geoJson.coordinates = [coordinates];
            }
            return geoJson;
        },
        /**
         * 自定义拾取图形
         * @private
         */
        _getMapPolt: function () {

            if (!this._getMapPoltListener) {
                var self = this;
                this._getMapPoltListener = function (options) {
                    var callback = self.param.callback;
                    var layerId = self.options.layerId;
                    var layers = self.param.map.getLayers();
                    var layer;
                    //获取标绘图层
                    for (var i = 0; i < layers.length; i++) {
                        if (layers[i].id == layerId) {
                            layer = layers[i];
                        }
                    }
                    var graphic = layer.hitTest(options.screenX, options.screenY);
                    //判断是否是面，只拾取polygon
                    if (graphic) {
                        var json = graphic.element.geometry.asGeoJson();
                        callback(json);
                        self.map.off('click', self._getMapPolt());
                    }
                }
            }
            return this._getMapPoltListener;
        },
        /**
         * 画缓冲圆的方法
         * @returns {Function|*}
         * @private
         */
        _getMapClickPoint: function () {
            if (!this._mapClickListener) {
                var self = this;
                this._mapClickListener = function (options) {
                    var callback = self.param.callback;
                    var symbol = self.param.symbol;
                    var drawLayer = self._layer;
                    var point = new g2.sfs.Point({
                        x: options.mapX,
                        y: options.mapY,
                        spatialReference: self.map.spatialReference
                    })
                    var markerSymbol = symbol || new g2.sfs.MarkerSymbol();
                    var markerEle = new g2.sfs.Element({
                        geometry: point,
                        symbol: markerSymbol
                    });
                    drawLayer.add(markerEle);
                    self.map.off('click', self._getMapClickPoint());
                    callback(point);
                }
            }
            return this._mapClickListener;
        },
        _sortFunction: function (arr, type) {
            var list = [];
            if (type == "LineString") {
                list = arr;
                list.sort(function (a, b) {
                    return a[0] < b[0] ? 1 : -1;
                })
            } else if (type == "Point") {
                list.push(arr);
            } else {

                for (var i = 0; i < arr.length; i++) {
                    var obj = arr[i];
                    for (var j = 0; j < obj.length; j++) {
                        list.push(obj[j]);
                    }
                }
                list.sort(function (a, b) {
                    return a[0] < b[0] ? 1 : -1;
                })
            }

            return list;
        },
    })
    return component;
})
